import { render, staticRenderFns } from "./SubscriptionAlertIndex.vue?vue&type=template&id=214a0d8f&scoped=true&"
import script from "./SubscriptionAlertIndex.vue?vue&type=script&lang=js&"
export * from "./SubscriptionAlertIndex.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionAlertIndex.vue?vue&type=style&index=0&id=214a0d8f&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214a0d8f",
  null
  
)

export default component.exports